import { createRouter, createWebHistory } from 'vue-router';
import CommunityView from '@/views/CommunityView';
import FeedView from '../views/FeedView.vue';
import ResourcesView from '../views/ResourcesView.vue';
import PlateToolView from '../views/PlateToolView';
import ToolsView from '../views/ToolsView';
import FaqView from '@/views/FaqView';
import RMTView from '@/views/RMTView';
import { useIdentityStore } from '@/store/IdentityStore';
// import { useDealerStore } from '@/store/DealerStore';
import ApiService from '@/services/ApiService';
import DealerEditorView from '@/views/DealerEditorView.vue';
// import TerritoryEditorView from '@/views/TerritoryEditorView.vue';

const routes = [
  {
    path: '/',
    name: 'default',
    // redirect: '/community/feed/all',
    meta: {
      title: 'Nelson Dealer Portal - Home',
    },
  },
  {
    path: '/community',
    name: 'community',
    meta: {
      title: 'Nelson Dealer Portal - Feed',
    },
    component: CommunityView,
    children: [
      {
        path: 'feed/:option',
        name: 'feed',
        props: true,
        component: FeedView,

      },
      {
        path: '/community/faq',
        name: 'faq',
        component: FaqView
      }
    ]
  },
  {
    path: '/resources',
    name: 'resources',
    meta: {
      title: 'Nelson Dealer Portal - Resources',
    },
    component: ResourcesView,
    children: [{
      path: 'whole-goods-price-list',
      name: 'whole-goods-price-list',
      component: ResourcesView
    }]
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: RMTView,
    meta: {
      title: 'Nelson Dealer Portal - Resource Library',
    },
    children: [
      {
        path: 'library',
        name: 'library',
        component: RMTView
      },
      {
        path: 'library/:option',
        name: 'library option',
        props: true,
        component: RMTView
      }
    ],
    props: route => ({ page: parseInt(route.query.page) || 1, limit: route.query.limit || null, filterTypes: route.query.filterTypes || 'all' })
  },
  {
    path: '/tools',
    name: 'tools',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    component: ToolsView
  },
  {
    path: '/rmt',
    name: 'rmt',
    meta: {
      title: 'Nelson Dealer Portal - Resources',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    component: RMTView
  },
  {
    path: '/plate_tool',
    name: 'Plate Tool',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    component: PlateToolView
  },
  {
    path: '/dealer_editor',
    name: 'Dealer Editor',
    component: DealerEditorView
  },
  // {
  //   path: '/territory_editor',
  //   name: 'Territory Editor',
  //   component: TerritoryEditorView
  // }
];
const webHistoryUrl = process.env.NODE_ENV !== 'production' ? '/' : '/dealerportal';
const router = createRouter({
  linkExactActiveClass: 'is-active',
  history: createWebHistory(webHistoryUrl),
  mode: 'history',
  base: webHistoryUrl,
  routes
});

router.beforeEach(async (to, from) => {
  const ident = useIdentityStore();
  // dynamic page title
  document.title = to.meta?.title ?? 'Nelson Dealer Portal';
  if (process.env.NODE_ENV !== 'production') {
    console.log('From Path: ' + from.path);
    console.log('To Path: ' + to.path);
  }
  if (to.fullPath.indexOf('callback') === -1) {
    // check to see if discovery document is stored
    if (!ident.discovery) {
      await ident.verifyDiscoveryDocument();
    }

    var token = ident.access_token();

    if (!token) // no token so we need to authenticate
    { ident.ssoAuthenticate(); }
    else {
      var bTokenActive = await ident.isTokenValid();

      if (!bTokenActive) {
        var refreshToken = ident.refresh_token();
        if (refreshToken) {
          await ident.ssoRefreshToken(refreshToken);
        }
      }
      if (!ApiService.hasToken()) {
        //   useDealerStore().fetchDealers()
        ApiService.setAuthHeader(ident.access_token());
        //   // useViewStore().getRecentTests(10)
        //   // useSprinklerStore().fetchData()
      }
      var user = JSON.parse(localStorage.getItem('portal_user'));
      if (!user) { ident.getTokenUser(); }
      else {
        ident.User = user;
      }

      if (!ApiService.token) { ApiService.token = token; }

    }
  }
});
router.onError(err => {
  print('<!-- router error: ' + err.message + ' -->');
});

export default router;